export var maxWidth = '680px';